// src/extenders/subject-switcher.js
var SubjectSwitcher = class extends HTMLElement {
  constructor() {
    super();
    const allSubjects = this.querySelectorAll(".js-faq-subject");
    const allQuestions = this.querySelectorAll(".js-faq-question");
    const allSubjectsWithIndexCheck = this.querySelectorAll(".js-subject-index");
    const handleSubjectSelection = (subject) => {
      allSubjects.forEach((subjectItem) => {
        subjectItem.getAttribute("aria-expanded") === "true" ? subjectItem.setAttribute("aria-expanded", "false") : "";
      });
      const subjectAriaControls = subject.getAttribute("aria-controls");
      const allMatchingControls = document.querySelectorAll(`[aria-controls="${subjectAriaControls}"]`);
      allMatchingControls.forEach((control) => {
        control.setAttribute("aria-expanded", "true");
      });
      allQuestions.forEach((question) => {
        const ariaLabelledByHighlight = question.getAttribute("aria-labelledby");
        if (ariaLabelledByHighlight === subjectAriaControls) {
          question.classList.remove("hidden");
          question.classList.add("block");
        } else {
          question.classList.remove("block");
          question.classList.add("hidden");
        }
      });
    };
    allSubjects.forEach((subject) => {
      subject.addEventListener("click", function() {
        handleSubjectSelection(subject);
      });
    });
    allSubjectsWithIndexCheck.forEach((subject, index) => {
      if (index === 0) {
        subject.setAttribute("aria-expanded", "true");
      }
    });
    allSubjects.forEach((subject) => {
      if (subject.getAttribute("aria-expanded") === "true") {
        handleSubjectSelection(subject);
      }
    });
  }
};
if (customElements.get("subject-switcher") === void 0) {
  customElements.define("subject-switcher", SubjectSwitcher);
}
